/**
 * 广告命名模板：本地工厂与默认值生成工具。
 * 用于初始化空白模板、给前端编辑态提供稳定的 ID（前端 UI 临时 ID）。
 */

import type {
  AdNameTemplate,
  Combo,
  EnumItem,
  SingleEnumCombo,
  TemplateField,
} from "../types/adNameTemplate.types";

let counter = 1;
function nextId(prefix: string): string {
  counter += 1;
  return `${prefix}_${Date.now().toString(36)}_${counter}`;
}

export function newEnumItem(
  code = "",
  meaning = "",
  order = 0,
): EnumItem {
  return {
    id: nextId("ei"),
    item_order: order,
    item_code: code,
    item_meaning: meaning,
  };
}

export function newSingleEnumCombo(
  items: EnumItem[] = [],
  setName: string | null = null,
): SingleEnumCombo {
  return {
    enum_set_id: nextId("es"),
    enum_set_name: setName,
    enum_items: items,
  };
}

export function newCombo(items: EnumItem[] = []): Combo {
  return {
    combo_type: "SINGLE_ENUM",
    single_enum_combo: newSingleEnumCombo(items),
    multi_enum_combo: null,
    date_combo: null,
    input_box_combo: null,
  };
}

export function newInputBoxCombo(hintText: string | null = null): Combo {
  return {
    combo_type: "INPUT_BOX",
    single_enum_combo: null,
    multi_enum_combo: null,
    date_combo: null,
    input_box_combo: { hint_text: hintText },
  };
}

export function newField(
  name: string,
  combos: Combo[] = [newCombo()],
  separatorToNext: string | null = null,
): TemplateField {
  return {
    id: nextId("f"),
    name,
    separator_to_next: separatorToNext,
    combos,
  };
}

export function newBlankTemplate(): AdNameTemplate {
  return {
    id: "",
    separator: "-",
    fields: [
      newField("拉新", [newCombo([newEnumItem("N", "广告拉新", 0)])], null),
      newField(
        "代理",
        [
          newCombo([
            newEnumItem("YK", "亿科", 1),
            newEnumItem("YR", "云锐", 2),
            newEnumItem("PR", "派瑞", 3),
            newEnumItem("YZ", "智云众", 4),
          ]),
        ],
        null,
      ),
    ],
  };
}

/**
 * 空白模板（无任何字段）：供「无平台默认字段」的域（如华为）作为编辑起点。
 * 腾讯请用 newBlankTemplate()（带腾讯代理默认枚举）。
 */
export function newEmptyTemplate(): AdNameTemplate {
  return { id: "", separator: "-", fields: [] };
}

export function reorderItems(items: EnumItem[]): EnumItem[] {
  return items.map((it, idx) => ({ ...it, item_order: idx }));
}